import type { Ticker, WindowKey } from '@meridian/contracts';

import { ROOT_KEY } from './root';

export const stockKeys = {
  all: [...ROOT_KEY, 'stock'] as const,
  security: (ticker: Ticker) => [...stockKeys.all, 'security', ticker] as const,
  series: (ticker: Ticker, window: WindowKey) =>
    [...stockKeys.all, 'series', ticker, window] as const,
  peers: (ticker: Ticker, window: WindowKey) =>
    [...stockKeys.all, 'peers', ticker, window] as const,
  diversifiers: (ticker: Ticker, window: WindowKey) =>
    [...stockKeys.all, 'diversifiers', ticker, window] as const,
  search: (q: string, limit: number) => [...stockKeys.all, 'search', q, limit] as const,
};
